import { SectionData } from '../../../annotations/models/annotationData';
import { QueueAction } from '../../../rules/models/queueRule';
import { SchemaSection } from '../../../schemas/models/schemaSection';
import { Message } from '../../../shared/models/message';
import { Url } from '../../../utils/codecUtils';
import {
  evaluateFormulasPayloadSchema,
  evaluateFormulasResponseSchema,
} from './evaluateFormulas.schema';

export type EvaluateFormulasPayload = {
  schemaContent: SchemaSection[];
  annotationContent: Array<SectionData>;
  annotation?: Url;
  queue?: Url;
};

export type AutomationBlocker = { content: string; id: string };

export type EvaluateFormulasResponse = {
  annotationContent: Array<SectionData>;
  automationBlockers: Array<AutomationBlocker>;
  messages: Array<Message>;
  actions?: Array<QueueAction>;
};

export const evaluateFormulas = (payload: EvaluateFormulasPayload) => {
  return {
    endpoint: `internal/schemas/evaluate_formulas`,
    method: 'POST',
    responseSchema: evaluateFormulasResponseSchema,
    payloadSchema: evaluateFormulasPayloadSchema,
    payload,
  } as const;
};
